import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ICONS_PREPEND, KEMONO_SITE, SITE_NAME } from "#env/env-vars";
import { fetchAnnouncements } from "#api/posts";
import { PageSkeleton } from "#components/pages";
import { CardList } from "#components/cards";
import { paysites } from "#entities/paysites";
import { IAnnouncement } from "#entities/posts";
import { AnnouncementPreview } from "#entities/posts";
import { OutletContext } from "./creator-page";

interface IProps {
  announcements: IAnnouncement[];
}

export function AnnouncementsPage() {
  const { announcements } = useLoaderData() as IProps;
  const { creator } = useOutletContext() as OutletContext;
  const paysite = paysites[creator.service];
  const title = `Announcements of "${creator.name}" from ${paysite.title}`;

  return (
    <PageSkeleton name="user" title={title}>
      <Helmet>
        <meta name="id" content={creator.id} />
        <meta name="service" content={creator.service} />
        <meta name="artist_name" content={creator.name} />
        {/* <link rel="canonical" href="{{ g.canonical_url }}" /> */}

        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta
          property="og:image"
          content={`${ICONS_PREPEND ?? KEMONO_SITE}/icons/${creator.service}/${creator.id}`}
        />
        {/* <meta property="og:url" content="{{ g.canonical_url }}" /> */}
      </Helmet>

      <CardList layout="phone">
        {!announcements.length ? (
          <div className="no-results">
            <h2 className="site-section__subheading">
              Nobody here but us chickens!
            </h2>
            <p className="subtitle">
              There are no Announcements for your query.
            </p>
          </div>
        ) : (
          announcements.map((announcement) => (
            <AnnouncementPreview
              key={announcement.hash}
              announcement={announcement}
            />
          ))
        )}
      </CardList>
    </PageSkeleton>
  );
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const profileID = params.creatorId!.trim();

  const announcements = fetchAnnouncements(service, profileID);

  return {
    announcements: await announcements,
  };
}
